// src/lib/useAuthUser.js
import React from "react";
import { subscribeToAuth } from "./auth";

export function useAuthUser() {
  const [user, setUser] = React.useState(undefined); // undefined = loading, null = logged out

  React.useEffect(() => {
    const unsub = subscribeToAuth((u) => setUser(u ?? null));
    return () => unsub();
  }, []);

  return user;
}
